import React, { useState } from 'react';
import { getCounterMessage } from '../../_utils/rcg/counter-identification';
import { QuestionOuiNon } from '../shared/question-oui-non';

function CounterMessageCard({ message }) {
    const isWarning = message.type === 'warning';
    return (
        <div className={`panel-card panel-card--${message.type}`}>
            <p>
                <i className={`fa fa-${isWarning ? 'exclamation-triangle' : 'check-circle'}`}></i>
                {' '}<b>{message.title}</b>
            </p>
            <p className={"grey"}>{message.subtitle}</p>
        </div>
    );
}

function RcgProductIdentification({ scanResult, submitted, submitting, submitError, onSubmit, onReset }) {
    const [isDamaged, setIsDamaged] = useState(null);

    const message = getCounterMessage(isDamaged);

    const handleValider = () => {
        if (isDamaged === null) return;
        onSubmit({ isDamaged });
    };

    if (submitted) {
        return (
            <div>
                <div className={"panel-card panel-card--success"}>
                    <p className={"green"}><i className={"fa fa-check-circle"}></i> <b>Matériel enregistré avec succès</b></p>
                </div>
                <div className={"btns"}>
                    <button type={"button"} className={"btn btn-scan-other full"} onClick={onReset}>
                        <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className={"product-id-card"}>
                <div className={"product-id-icon"}>
                    <i className={"fa fa-gauge"}></i>
                </div>
                <div className={"product-id-info"}>
                    <p className={"product-id-name"}>{scanResult.product.name}</p>
                    <p className={"product-id-manufacturer"}>{scanResult.manufacturer.name}</p>
                </div>
            </div>

            <div className={"panel-card"}>
                <p className={"rcg-card-title"}>Type de matériel</p>
                <QuestionOuiNon
                    label={"Le matériel est-il endommagé ?"}
                    value={isDamaged}
                    onChange={setIsDamaged}
                />
            </div>

            {message && <CounterMessageCard message={message} />}

            {submitError && (
                <p className={"red text-center mt_15"}>
                    <i className={"fa fa-exclamation-circle"}></i> Une erreur est survenue, veuillez réessayer.
                </p>
            )}

            <div className={"btns"}>
                <button
                    type={"button"}
                    className={"btn btn-full-green full"}
                    disabled={isDamaged === null || submitting}
                    onClick={handleValider}
                >
                    {submitting ? 'Envoi en cours...' : 'Valider'}
                </button>
                <button type={"button"} className={"btn btn-scan-other full mt_15"} onClick={onReset}>
                    <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                </button>
            </div>
        </div>
    );
}

export { RcgProductIdentification };
